import * as React from 'react';

// Components
import Box from '../../components/Box';
import Button from '../../components/Button';
import Icon from '../../components/Icon';
import IconButton from '../../components/IconButton';
import List, {
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction
} from '../../components/List';

// Component
interface IProps {
  name: string;
  email: string;
  mobile: string;
  onEdit: () => void;
  userRole: string;
}

function UserDialogDetailsView(props: IProps) {
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <List
        className="AppWorkspacePerson__PersonDetails__list"
        style={{ flexGrow: 1 }}
        disablePadding={true}
      >
        <ListItem>
          <ListItemIcon>
            <Icon>person</Icon>
          </ListItemIcon>
          <ListItemText primary={props.name} secondary="Name" />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <Icon>mail</Icon>
          </ListItemIcon>
          <ListItemText primary={props.email} secondary="Email" />
          <ListItemSecondaryAction>
            <IconButton
              onClick={() => (window.location.href = `mailto:${props.email}`)}
            >
              <Icon>send</Icon>
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <Icon>smartphone</Icon>
          </ListItemIcon>
          <ListItemText primary={props.mobile} secondary="Mobile" />
          <ListItemSecondaryAction>
            <IconButton
              onClick={() => (window.location.href = `tel:${props.mobile}`)}
            >
              <Icon>call</Icon>
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      </List>
      {props.userRole === 'ADMIN' ? (
        <div>
          <Box pa={3}>
            <Button
              raised={true}
              color="primary"
              style={{ width: '100%' }}
              onClick={props.onEdit}
            >
              Edit User
            </Button>
          </Box>
        </div>
      ) : null}
    </div>
  );
}

export default UserDialogDetailsView;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkPeopleSearch/UserDialogDetailsView.tsx